import { Button, Modal } from 'antd';
import React from 'react';
import { BULK_ACTION } from '../../../common/constants';

const BulkChecklistConfirmationModal = ({
  onCancel,
  onConfirm,
  action,
  visible = false,
  count = 0,
  loading = false,
}) => {
  const handleConfirm = () => {
    if (onConfirm && typeof onConfirm === 'function') {
      onConfirm();
    }
  };

  const handleCancel = () => {
    if (onCancel && typeof onCancel === 'function') {
      onCancel();
    }
  };

  // Dynamic title and message with proper pluralization
  const getTitle = () => {
    if (action === BULK_ACTION.ACTIVATE) return 'Activate';
    if (action === BULK_ACTION.DEACTIVATE) return 'Deactivate';
    if (action === BULK_ACTION.DELETE) return 'Delete';
    return 'Update';
  };
  const getMessage = () => {
    if (action === BULK_ACTION.ACTIVATE)
      return 'Any checklist already active will be skipped.';
    if (action === BULK_ACTION.DEACTIVATE)
      return 'Any checklist already deactive will be skipped.';
    if (action === BULK_ACTION.DELETE)
      return 'This checklists will be permanently deleted and will not be available.';
    return '';
  };
  const title = getTitle();
  const checklistText = count === 1 ? 'Checklist' : 'Checklists';

  return (
    <Modal
      maskClosable={false}
      centered
      closable={false}
      footer={null}
      open={visible}
      onCancel={handleCancel}
    >
      <h2>
        {title} {count} {checklistText}
      </h2>
      <p>{getMessage()}</p>
      <div className="form-buttons">
        <Button
          shape="round"
          className="cancel-button"
          onClick={handleCancel}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          shape="round"
          type="primary"
          className="save-button"
          onClick={handleConfirm}
          loading={loading}
          disabled={loading}
        >
          Confirm
        </Button>
      </div>
    </Modal>
  );
};

export default BulkChecklistConfirmationModal;
